import { motion } from 'framer-motion'
import DocsLayout from '../components/DocsLayout'
import SEO from '../components/SEO'
import { 
  FaKey, 
  FaDragon, 
  FaCloud, 
  FaTools, 
  FaBolt, 
  FaBullseye, 
  FaSync, 
  FaWrench, 
  FaWindows, 
  FaLightbulb,
  FaCompactDisc,
  FaDownload,
  FaApple,
  FaUsb,
  FaDesktop
} from 'react-icons/fa'

const activators = [
  {
    name: "HEU KMS Activator",
    description: "支持Windows和Office所有版本的激活工具，无需联网即可一键激活。提供多种激活方式，包括数字许可证、KMS38、OEM、KMS等，并且支持UEFI的KMS激活。",
    url: "https://github.com/zbezj/HEU_KMS_Activator",
    icon: <FaKey className="text-yellow-500" />,
    features: ["支持所有版本", "多种激活方式", "无需联网", "支持UEFI"]
  },
  {
    name: "MicroKMS神龙版",
    description: "能激活各类Windows系统版本，包括专业工作站版、企业版、专业版、教育版、专业教育版、家庭版，同时支持激活Office 365。",
    url: "http://www.yishimei.cn/network/319.html",
    icon: <FaDragon className="text-red-500" />,
    features: ["支持多种版本", "支持Office 365", "一键激活", "稳定可靠"]
  },
  {
    name: "云萌Windows 10+ 激活工具",
    description: "一款开源的Win10/11数字激活工具，可以一键免费终身激活，享受正版相同服务。每次重装自动激活，更换硬件支持Microsoft账户迁移激活。",
    url: "https://cmwtat.cloudmoe.com/cn.html",
    icon: <FaCloud className="text-blue-300" />,
    features: ["开源工具", "终身激活", "自动激活", "支持迁移"]
  },
  {
    name: "Ratiborus KMS Tools",
    description: "一款由俄罗斯开发者Ratiborus制作的Windows和Office激活工具集。它是一个全功能的KMS激活工具，能够一键激活所有版本的Windows和Office产品。",
    url: "https://ratiborus.com/kms-tools-free-download",
    icon: <FaTools className="text-gray-600" />,
    features: ["全功能工具集", "一键激活", "支持Office", "持续更新"]
  },
  {
    name: "MAS",
    description: "一个用于激活Windows和Office的工具，使用了HWID、Ohook、KMS38和Online KMS等激活方法。",
    url: "https://github.com/massgravel/Microsoft-Activation-Scripts",
    icon: <FaBolt className="text-yellow-400" />,
    features: ["多种激活方法", "开源工具", "支持Office", "持续更新"]
  },
  {
    name: "KMSpico",
    description: "一个非常成功、经常更新且100%干净的工具，可以在几秒钟内永久激活Windows或Microsoft Office的任何版本。",
    url: "https://www.getkmspico.com/download",
    icon: <FaBullseye className="text-red-400" />,
    features: ["快速激活", "永久激活", "支持Office", "干净无捆绑"]
  },
  {
    name: "KMS Auto Net Activator",
    description: "一个著名的Windows激活工具，用于激活Windows 7、8、8.1、10和Office 2010-2016的工具。",
    url: "https://www.kmsauto.info/",
    icon: <FaSync className="text-green-500" />,
    features: ["支持旧版本", "支持Office", "简单易用", "稳定可靠"]
  },
  {
    name: "Microsoft Toolkit",
    description: "一款老牌的免费版激活工具，可以用来激活MS Office和Windows系统，它和KMSpico原理是一样的。",
    url: "https://www.officialmstoolkit.com/",
    icon: <FaWrench className="text-blue-500" />,
    features: ["老牌工具", "支持Office", "免费使用", "稳定可靠"]
  },
  {
    name: "Windows Activator",
    description: "Windows激活程序，使用此程序，可以免费激活Windows 11、10、8.1、8和7。",
    url: "https://github.com/muki01/Windows-Activator",
    icon: <FaWindows className="text-blue-600" />,
    features: ["支持新版本", "开源工具", "简单易用", "持续更新"]
  },
  {
    name: "ActivationHelper",
    description: "一个开源的实用工具，旨在帮助用户管理其Windows操作系统的激活。",
    url: "https://github.com/HorridHanu/WindowsActivationHelper",
    icon: <FaLightbulb className="text-amber-400" />,
    features: ["开源工具", "激活管理", "简单易用", "持续更新"]
  }
]

const sidebarItems = [
  { title: "装机工具", path: "/tools", icon: <FaTools /> },
  { title: "PE工具", path: "/petools", icon: <FaCompactDisc /> },
  { title: "激活工具", path: "/activators", icon: <FaKey /> },
  { title: "系统下载", path: "/downloads", icon: <FaDownload /> },
  { title: "Windows软件", path: "/windows-software", icon: <FaWindows /> },
  { title: "MacOS软件", path: "/macos-software", icon: <FaApple /> },
  { title: "安装U盘推荐", path: "/usb-recommend", icon: <FaUsb /> },
  { title: "电脑选购推荐", path: "/computer-recommend", icon: <FaDesktop /> }
]

const Activators = () => {
  return (
    <DocsLayout sidebarItems={sidebarItems}>
      <SEO 
        title="Windows激活工具大全 | Win10/Win11/Office激活软件推荐"
        description="精选收录多款优质Windows激活工具，包括HEU KMS、云萌激活等，支持Windows 10/11和Office所有版本激活，一键永久激活系统，安全可靠无广告。"
        keywords="Windows激活工具,Win10激活,Win11激活,Office激活,KMS激活工具,数字权利激活,HEU KMS,永久激活Windows,系统激活软件"
      />
      <motion.h1 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-3xl font-bold text-primary mb-8 text-center"
      >
        Windows激活工具 <FaKey className="inline text-primary ml-1" />
      </motion.h1>

      <div className="mb-8 text-center text-gray-600">
        <p className="text-lg">
          众所周知，MSDN是不提供激活工具的，但这里有~总共十款激活工具，
          有KMS神龙激活、一键激活脚本、云萌数字激活、HEU KMS Activator.....不怕激活不成功。
        </p>
      </div>
      
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {activators.map((activator, index) => (
          <motion.div
            key={activator.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="card"
          >
            <div className="flex items-center mb-4">
              <div className="text-2xl mr-3">{activator.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800">{activator.name}</h3>
            </div>
            <p className="text-gray-600 mb-4">{activator.description}</p>
            <div className="mb-4">
              <h4 className="font-medium text-gray-700 mb-2">特点：</h4>
              <ul className="list-disc list-inside text-sm text-gray-600">
                {activator.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
            </div>
            <a
              href={activator.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
            >
              获取工具
            </a>
          </motion.div>
        ))}
      </div>
    </DocsLayout>
  )
}

export default Activators 